// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__38BT6","head":"Table_head__3pi5D","col":"Table_col__2rL66"};